module.exports = __webpack_public_path__ + "img/1.f51f0e98.png";